import * as React from 'react';

function DividerCurveSvg(props) {
    return (
        <svg
            width="100%"
            height={34}
            viewBox="0 0 1303 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            {...props}
        >
            <path
                d="M11 18.27c41.647-7.497 81.799-8.946 123.43-8.023 33.921.752 67.753 3.558 101.585 4.012 28.532.383 56.868 4.012 85.418 4.012 35.6 0 70.886-6.997 106.39-6.018 23.972.661 48.109 5.445 72.311 5.906 25.985.496 51.998.112 77.99.112 20.104 0 39.984 2.005 60.077 2.005 22.117 0 43.777-4.901 65.866-3.9 82.147 3.725 165.441.008 247.734-2.34 47.175-1.346 94.039-2.242 141.239-1.783 32.07.312 64.26 3.775 96.34 4.903 23.42.824 48.86-2.16 72.09 1.226 6.37.928 11.12 3.9 17.69 3.9 3.67 0 19.38 3.865 11.8 0"
                stroke="#ECECEC"
                strokeWidth={20}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default DividerCurveSvg;
